import { useEffect } from 'react';
import { useTankCleaningStore } from '../context/TankCleaningContext';
import { ChemicalOrderPortCall } from '../types/ViewModel/TankCleaning/Order/ChemicalOrderPortCall';
import { createChemicalOrderPortCallList } from '../factory/TankCleaning/ChemicalOrderPortCallFactory';
import { ChemicalOrderPortCallBM } from '../types/BusinessModel/TankCleaning/ChemicalOrderPortCallBM';
import useApi from './useApi';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { setSelectedChemicalOrderForPortCallList, setSelectedChemicalOrderId } = useTankCleaningStore();
    const { state, postApiData } = useApi();

    useEffect(() => {
        if (state.status === 'success') {
            if (state.endpoint === apiEndpoints['upsertChemicalOrder'].url) {
                const _chemicalOrderPortCallList: ChemicalOrderPortCall[] = createChemicalOrderPortCallList(state.result);
                if (_chemicalOrderPortCallList) {
                    setSelectedChemicalOrderId(null);
                    setSelectedChemicalOrderForPortCallList([..._chemicalOrderPortCallList]);
                }
            }
            if (state.endpoint === apiEndpoints['deleteChemicalOrderDraft'].url) {
                const _chemicalOrderPortCallList: ChemicalOrderPortCall[] = createChemicalOrderPortCallList(state.result);
                if (_chemicalOrderPortCallList) {
                    setSelectedChemicalOrderId(null);
                    setSelectedChemicalOrderForPortCallList([..._chemicalOrderPortCallList]);
                }
            }
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    const upsertChemicalOrder = async (chemicalOrderPortCall: ChemicalOrderPortCallBM, imoNumber: number) =>
        await postApiData({
            endpoint: apiEndpoints['upsertChemicalOrder'].url,
            data: chemicalOrderPortCall,
            queryParam: buildQueryParams({ imoNumber: imoNumber }),
        });

    const deleteChemicalOrderDraft = async (imoNumber: number, chemicalOrderId: number) => {
        await postApiData({
            endpoint: apiEndpoints['deleteChemicalOrderDraft'].url,
            queryParam: buildQueryParams({ imoNumber, chemicalOrderId }),
        });
    };

    return {
        upsertChemicalOrder,
        deleteChemicalOrderDraft,
    };
};
